import type { ProductFilterSchema } from '@coas/validators/payload';

export const filterItems = [
    { key: 'brands', title: 'Бренды' },
    { key: 'colors', title: 'Цвета' },
    { key: 'sizes', title: 'Размеры' },
    { key: 'price', title: 'Цена' },
] satisfies Array<{
    key: keyof ProductFilterSchema;
    title: string;
}>;
